import { NoteModel } from '@models/note';
import http from '@/utils/http';

const filterNotes = (note, searchQuery, successCallback) => {
  http.get(`${note.routes.all}${searchQuery}`)
    .then((response) => {
      successCallback(response.data);
    })
    .catch(() => {
      window.flashMessages.addMessage({
        type: 'error',
        text: 'Notes can not be filter due to some errors.',
      });
    });
};

// Deliberately does NOT filter by cart: the notes list shows the patient's whole
// history on every cart. Each note card already prints its own "Cart: <id>".
const updateNotes = (userId, callbackMethod) => {
  const note = new NoteModel();
  const searchQuery = note.searchQuery({
    currentUserId: userId,
  });

  filterNotes(note, searchQuery, callbackMethod);
};

export { filterNotes, updateNotes };
